import * as actionTypes from '../actionTypes/fetchApi';

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.FETCH_API: {
      return state;
    }
    case actionTypes.FETCH_API_FULFILLED: {
      return {
        ...state,
        [action.payload.apiName]: {
          ...state[action.payload.apiName],
          response: action.payload.apiResponse,
        },
      };
    }
    case actionTypes.FETCH_API_REJECTED: {
      return {
        ...state,
        [action.payload.apiName]: {
          ...state[action.payload.apiName],
          error: action.payload.error,
        },
      };
    }
    case actionTypes.SET_POINT_BENEFIT_DATA_FROM_JUNSI: {
      return {
        ...state,
        pointBenefit: action.payload.data,
      };
    }
    case actionTypes.SET_PAY_DISCOUNT_DATA_FROM_JUNSI: {
      return {
        ...state,
        payDiscount: action.payload.data,
      };
    }
    case actionTypes.SET_PROMOTION_BANNER_FROM_JUNSI: {
      return {
        ...state,
        promotionBanner: action.payload.data,
      };
    }
    case actionTypes.SET_META_CARD_DISCOUNT_DATA_FROM_JUNSI: {
      return {
        ...state,
        metaCardDiscount: action.payload.data,
      };
    }
    default:
      return state;
  }
};
